import React, { useState } from 'react';
import { Title, Text, SimpleGrid, Button, Modal, Group } from '@mantine/core';
import { Plus, RefreshCw, PhoneOff } from 'lucide-react';
import { NumberWidget } from '../components/NumberWidget';
import { useNavigate } from 'react-router-dom';
export function NumbersPage() {
  const navigate = useNavigate();
  const [numbers, setNumbers] = useState([{
    phoneNumber: '+55 11 99999-9999',
    name: 'WhatsApp Principal',
    isActive: true,
    lastConnection: 'Hoje, 10:45',
    iconColor: '#0047AB'
  }, {
    phoneNumber: '+55 11 88888-8888',
    name: 'Atendimento',
    isActive: true,
    lastConnection: 'Hoje, 09:30',
    iconColor: '#00A86B'
  }, {
    phoneNumber: '+55 11 77777-7777',
    name: 'Vendas',
    isActive: false,
    lastConnection: 'Ontem, 18:15',
    iconColor: '#FFCC00'
  }]);
  const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
  const [optionsModalOpened, setOptionsModalOpened] = useState(false);
  const [confirmModalOpened, setConfirmModalOpened] = useState(false);
  const handleNumberClick = (phoneNumber: string) => {
    setSelectedNumber(phoneNumber);
    setOptionsModalOpened(true);
  };
  const handleReconnect = () => {
    setOptionsModalOpened(false);
    navigate('/qrcode');
  };
  const handleDisconnectClick = () => {
    setOptionsModalOpened(false);
    setConfirmModalOpened(true);
  };
  const handleConfirmDisconnect = () => {
    if (selectedNumber) {
      setNumbers(prev => prev.map(num => num.phoneNumber === selectedNumber ? {
        ...num,
        isActive: false
      } : num));
    }
    setConfirmModalOpened(false);
    setSelectedNumber(null);
  };
  const handleCancelDisconnect = () => {
    setConfirmModalOpened(false);
  };
  const selectedNumberData = numbers.find(num => num.phoneNumber === selectedNumber);
  return <div className="space-y-6" data-id="element-510">
      <div className="flex justify-between items-center" data-id="element-511">
        <div data-id="element-512">
          <Title order={2} className="text-primary" data-id="element-513">
            Números
          </Title>
          <Text c="dimmed" data-id="element-514">Gerencie seus números de WhatsApp</Text>
        </div>
        <Button leftSection={<Plus size={18} data-id="element-516" />} onClick={() => navigate('/qrcode')} radius="lg" styles={{
        root: {
          backgroundColor: '#00A86B',
          height: '48px',
          '&:hover': {
            backgroundColor: '#008c5a'
          }
        }
      }} data-id="element-515">
          Adicionar Número
        </Button>
      </div>
      <SimpleGrid cols={{
      base: 1,
      sm: 2,
      lg: 3
    }} className="mt-6" data-id="element-517">
        {numbers.map((number, index) => <NumberWidget key={index} {...number} onClick={() => handleNumberClick(number.phoneNumber)} data-id="element-518" />)}
      </SimpleGrid>
      {/* Options Modal */}
      <Modal opened={optionsModalOpened} onClose={() => setOptionsModalOpened(false)} title={<Text fw={600} size="lg" data-id="element-520">
            {selectedNumberData?.name}
          </Text>} centered size="md" data-id="element-519">
        <div className="space-y-3" data-id="element-521">
          <Text size="sm" c="dimmed" mb="lg" data-id="element-522">
            {selectedNumberData?.phoneNumber}
          </Text>
          <Button fullWidth leftSection={<RefreshCw size={18} data-id="element-524" />} onClick={handleReconnect} radius="lg" styles={{
          root: {
            backgroundColor: '#0047AB',
            height: '48px',
            '&:hover': {
              backgroundColor: '#003d91'
            }
          }
        }} data-id="element-523">
            Reconectar número
          </Button>
          <Button fullWidth leftSection={<PhoneOff size={18} data-id="element-526" />} onClick={handleDisconnectClick} radius="lg" styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #dc2626',
            color: '#dc2626',
            height: '48px',
            '&:hover': {
              backgroundColor: '#fef2f2'
            }
          }
        }} data-id="element-525">
            Desconectar
          </Button>
        </div>
      </Modal>
      {/* Confirmation Modal */}
      <Modal opened={confirmModalOpened} onClose={() => setConfirmModalOpened(false)} title={<Text fw={600} size="lg" data-id="element-528">
            Confirmar desconexão
          </Text>} centered size="sm" data-id="element-527">
        <Text size="sm" mb="lg" data-id="element-529">
          Tem certeza que deseja desconectar este número?
        </Text>
        <Group grow data-id="element-530">
          <Button onClick={handleCancelDisconnect} radius="lg" styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #9ca3af',
            color: '#4b5563',
            height: '48px',
            '&:hover': {
              backgroundColor: '#f3f4f6'
            }
          }
        }} data-id="element-531">
            Não
          </Button>
          <Button onClick={handleConfirmDisconnect} radius="lg" styles={{
          root: {
            backgroundColor: '#dc2626',
            height: '48px',
            '&:hover': {
              backgroundColor: '#b91c1c'
            }
          }
        }} data-id="element-532">
            Sim
          </Button>
        </Group>
      </Modal>
    </div>;
}